module.exports = __webpack_public_path__ + "img/c49.be739778.png";